import { render, staticRenderFns } from "./ConsentInput.vue?vue&type=template&id=6e64119a&"
import script from "./ConsentInputVue.ts?vue&type=script&lang=ts&"
export * from "./ConsentInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports